import { css } from 'styled-components';
import { COLORS, METRICS } from '../../design/tokens';

const { HEADER_CONTENT } = METRICS;

const styles = {
  rootContainer: css`
    display: flex;
    align-items: center;
    flex: 1;
    height: 392px;
    width: 100%;
    padding: ${HEADER_CONTENT.PADDING_TOP} ${HEADER_CONTENT.PADDING_RIGHT}
      ${HEADER_CONTENT.PADDING_BOTTOM} ${HEADER_CONTENT.PADDING_LEFT};
    background-color: ${COLORS.SEA_BLUE};
    box-shadow: 0 2px 4px 0 rgba(0, 80, 91, 0.21);
  `,
  titleContainer: css`
    padding-bottom: 50px;
    text-align: center;
    line-height: 40px;
    white-space: nowrap;
  `
};

export default styles;
